import {Injectable} from "@angular/core";
import { saveAs } from 'file-saver';

@Injectable()
export class DownloadFileUtil {
    constructor() {
    }
   downloadFile(base64Str: string, contentType: string, fileName: string): any {
        let byteCharacters: any = atob(base64Str);
        let byteNumbers: any = new Array(byteCharacters.length);
        for (let i: any = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
       
        let byteArray: any = new Uint8Array(byteNumbers);
        let blob: any = new Blob([byteArray], { type: contentType });
        saveAs(blob, fileName);
        
    }
}



